export default __webpack_public_path__ + "static/media/dego-screenshot-03.89f86b4c.png";